import React from 'react';

import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent';

const UpdateAvailableBannerView = ({className}) => {
    const {icon, button} = appContent.getUpdateFirmwareInfoBlock();

    if (!button && !icon) return;

    const {title, description} = icon || {};

    const onClick = () => {
        //TODO: redirect or show Software Update screen
    };

    return (
        <div className={className}>
            <div className='flex w-full flex-col gap-4 rounded-xl bg-romance p-4 ml:bg-primary-dark-5'>
                <div className='flex items-start gap-2'>
                    <RemoteIconV2 icon={icon} className='h-12 w-12' />
                    <div>
                        <h2 className='mb-0 text-16 font-bold'>{title}</h2>
                        <p className='text-14 tracking-04'>{description}</p>
                    </div>
                </div>
                {button && (
                    <AppButton className='mt-0' secondary light aria-label={button.alt} onClick={onClick}>
                        {button.text}
                    </AppButton>
                )}
            </div>
        </div>
    );
};

export default UpdateAvailableBannerView;
